import ErrorImg from "Shared/Assets/Images/Background/errorimg.svg";
import { Box, Button, Container, Typography } from "@mui/material";
import { Link } from "react-router-dom";

//TODO[ADRIAN]: Fix all svgs in Images.
export const ErrorPage = () => (
	<Box
		display="flex"
		flexDirection="column"
		height="100vh"
		textAlign="center"
		justifyContent="center"
	>
		<Container maxWidth="md">
			<img src={ErrorImg} alt="404" />
			<Typography align="center" variant="h1" mb={4}>
				Opps!!!
			</Typography>
			<Typography align="center" variant="h4" mb={4}>
				This page you are looking for could not be found.
			</Typography>
			<Button
				color="primary"
				variant="contained"
				component={Link}
				to="/"
				disableElevation
			>
				Go Back to Home
			</Button>
		</Container>
	</Box>
);
